import { render } from "./customCalendar.vue?vue&type=template&id=1560a262"
import script from "./customCalendar.vue?vue&type=script&lang=js"
export * from "./customCalendar.vue?vue&type=script&lang=js"

import "./customCalendar.vue?vue&type=style&index=0&id=1560a262&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__